import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const pendingApprovalFilter = (): FilterDefinition => ({
  label: i18n.t('expenses_v2.list.filters.pending_approval'),
  type: 'in',
  options: {
    options: [
      {
        label: i18n.t('expenses_v2.list.filters.mine'),
        value: 'mine',
      },
      {
        label: i18n.t('expenses_v2.list.filters.all'),
        value: 'all',
      },
    ],
  },
})
